import React from "react";
import ReactMarkdown from "react-markdown";
import { NotificationRendererProps } from "./NotificationRendererProps";
import { ContactSupportRounded } from "@material-ui/icons";
import { userRendererStyles } from "./userRendererStyles";

export const ApqRenderer: React.FC<NotificationRendererProps> = ({
  notification,
}) => {
  const classes = userRendererStyles();
  return (
    <div>
      <div className={classes.iconSection}>
        <ContactSupportRounded color="secondary" fontSize="large" />
      </div>
      <div className={classes.detailSection}>
        <ReactMarkdown>{notification.summary}</ReactMarkdown>
      </div>
    </div>
  );
};
